// extracted by mini-css-extract-plugin
module.exports = {"textPreLine":"FrequentlyAskedQuestionSection__textPreLine___1jlsB"};